import React from "react";
import { NavLink } from "react-router-dom";

import _ from "i18n";
import { SVG_ICONS } from "Config";

export const SubMenuLink = ({ pathname, title, icon, children }) => {
  return (
    <li>
      <NavLink
        to={{ pathname }}
        activeClassName={"active"}
        className="menu__link"
      >
        {icon ? <img src={"/img/icons/" + SVG_ICONS[icon]} alt={""} /> : null}
        {children}
        <span className="title">{_(title)}</span>
      </NavLink>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SubMenuLink.js